<style lang="less" scoped>
/* 三列时固定 450px×3+边距会超出主区域，改为可收缩 + 允许换行 */
.detail-form-parent-div .flex {
  flex-wrap: wrap;
}

.detail-from-input {
  box-sizing: border-box;
  width: auto;
  flex: 1 1 300px;
  min-width: 0;
  max-width: 450px;
  margin: 10px 30px;
}

/* 与 .detail-from-input 同宽占位，保证两列表单项与上行三列网格对齐 */
.param-grid-col-placeholder {
  box-sizing: border-box;
  width: auto;
  flex: 1 1 300px;
  min-width: 0;
  max-width: 450px;
  margin: 10px 30px;
}

.detail-form-parent-div .flex .detail-from-input {
  flex: 1 1 300px;
  min-width: 0;
  max-width: 450px;
}

.margin-bt-10 {
  margin-bottom: 40px;
}

.detail-body-title {
  font-size: 15px;
  font-weight: 600;
  margin-bottom: 10px;
}

/* 底部：图片上传 + 状态 同一行对齐 */
.logo-status-footer {
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap;
  gap: 16px 32px;
}

.detail-form-logo-row {
  margin: 10px 30px !important;
  flex: 1;
  min-width: 320px;
  margin-bottom: 0 !important;
}

.detail-form-logo-row ::v-deep .el-form-item__label {
  font-weight: 600;
  font-size: 15px;
  line-height: 32px;
  padding-bottom: 0;
}

.detail-form-logo-row ::v-deep .el-form-item__content {
  line-height: 32px;
}

.detail-form-status-row {
  margin: 10px 30px !important;
  flex-shrink: 0;
  width: 100%;
  max-width: 450px;
  box-sizing: border-box;
}

.detail-form-status-row ::v-deep .el-form-item__label {
  font-weight: 600;
  font-size: 15px;
  line-height: 32px;
  padding-bottom: 0;
}

.detail-form-status-row ::v-deep .el-form-item__content {
  line-height: 32px;
}

.app-card-style img {
  width: 350px;
  height: 160px;
  border-radius: 5px;
  cursor: pointer;
}

.app-card-style {
  display: flex;
  flex-direction: column;
}

.box {
  position: relative;
  width: 348px;
  height: 160px;
  overflow: hidden;
  border: 3px solid #4390df;
  border-radius: 6px;

}

.box:before {
  position: absolute;
  display: block;
  border-top: 20px solid #4390df;
  border-left: 20px solid transparent;
  right: 0;
  top: 0;
  content: "";
  z-index: 101;
}

.box:after {
  position: absolute;
  display: block;
  content: "\2714";
  top: -3px;
  right: 0;
  font-family: Glyphicons Halflings;
  font-size: 3pt;
  font-weight: normal;
  z-index: 102;
  color: #fff;
}

.img-div {
  margin: 10px 45px;
}

.detail-table {
  margin-top: 20px;
}

// 充电桩图片选择器
.pile-img-picker {
  display: flex;
  align-items: center;
}

.pile-img-box {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 110px;
  height: 110px;
  overflow: hidden;
  background: #fbfdff;
  border: 1px dashed #c0ccda;
  border-radius: 6px;
  cursor: pointer;

  > .el-icon-plus {
    font-size: 26px;
    color: #8c939d;
  }

  &:hover {
    border-color: #409eff;

    .pile-img-mask {
      opacity: 1;
    }
  }
}

.pile-img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.pile-img-mask {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  color: #fff;
  background: rgba(0, 0, 0, 0.45);
  opacity: 0;
  transition: opacity 0.2s;

  span {
    display: flex;
    align-items: center;

    + span {
      margin-left: 12px;
    }

    i {
      margin-right: 3px;
    }
  }

  .pile-img-mask-del:hover {
    color: #f56c6c;
  }
}

.pile-img-side {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-left: 14px;

  .el-upload__tip {
    margin-top: 8px;
    line-height: 1.5;
    white-space: normal;
  }
}

// 桩图片库弹框
.img-lib-upload-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 14px;
}

.img-lib-upload-tip {
  font-size: 13px;
  color: #909399;

  i {
    margin-right: 4px;
    color: #409eff;
  }
}

.img-lib-upload-oper {
  display: flex;
  align-items: center;
}

.img-lib-name-input {
  width: 200px;
  margin-right: 10px;
}

.img-lib-grid {
  display: flex;
  flex-wrap: wrap;
  align-content: flex-start;
  min-height: 200px;
  max-height: 430px;
  overflow-y: auto;
}

.img-lib-item {
  position: relative;
  width: 148px;
  padding: 8px;
  margin: 0 14px 14px 0;
  text-align: center;
  border: 2px solid #e4e7ed;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    border-color: #409eff;
    box-shadow: 0 2px 10px rgba(64, 158, 255, 0.25);
  }

  &.active {
    background: #ecf5ff;
    border-color: #409eff;

    .img-lib-check {
      opacity: 1;
    }
  }

  img {
    width: 100%;
    height: 96px;
    object-fit: contain;
  }
}

.img-lib-name {
  margin-top: 6px;
  overflow: hidden;
  font-size: 12px;
  color: #606266;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.img-lib-check {
  position: absolute;
  top: 4px;
  right: 4px;
  font-size: 20px;
  color: #409eff;
  background: #fff;
  border-radius: 50%;
  opacity: 0;
}

.img-lib-preview-btn {
  position: absolute;
  top: 4px;
  left: 4px;
  width: 24px;
  height: 24px;
  font-size: 15px;
  line-height: 24px;
  text-align: center;
  color: #fff;
  background: rgba(0, 0, 0, 0.5);
  border-radius: 50%;
  cursor: pointer;
  opacity: 0;
  transition: all 0.2s;

  &:hover {
    background: rgba(0, 0, 0, 0.75);
  }
}

.img-lib-item:hover .img-lib-preview-btn {
  opacity: 1;
}

.img-lib-preview-img {
  display: block;
  width: 100%;
  max-height: 60vh;
  object-fit: contain;
}

.img-lib-empty {
  width: 100%;
  padding: 50px 0;
  text-align: center;
  color: #909399;

  i {
    font-size: 42px;
  }

  p {
    margin-top: 10px;
    font-size: 13px;
  }
}

.img-lib-file-info {
  display: flex;
  align-items: center;
  margin-top: 8px;

  .img-lib-file-thumb {
    width: 48px;
    height: 48px;
    object-fit: contain;
    border: 1px solid #ebeef5;
    border-radius: 4px;
    background: #f7f8fa;
    margin-right: 8px;
  }

  .img-lib-file-name {
    color: #606266;
    font-size: 12px;
    word-break: break-all;
  }
}

.img-lib-upload-tip-text {
  color: #909399;
  font-size: 12px;
  line-height: 1.5;
  margin-top: 4px;
}
</style>

<template>
  <div class="detail-container">
    <div class="detail-bread-crumb-div">
      <ZD-bread-crumb :bConfigList="pageConfig.detailBreadCrumb"></ZD-bread-crumb>
    </div>
    <div class="detail-content-div">
      <div class="detail-content-header-div flex">
        <div class="left-page-title-div flex-1">{{ pageTitle }}</div>
      </div>
      <div class="detail-content-body-div flex-1">
        <el-form :model="detailForm" :rules="detailFormRules" ref="detailForm" class="detail-form">
          <div class="detail-form-parent-div">
            <div class="margin-bt-10">
              <div class="detail-body-title">基础信息</div>
              <div class="flex">
                <el-form-item class="detail-from-input" label="充电桩显示名称" prop="showName">
                  <el-input v-model="detailForm.showName" clearable size="small" placeholder="请输入充电桩显示名称"
                    maxlength="25"></el-input>
                </el-form-item>
                <el-form-item class="detail-from-input" label="充电桩型号" prop="pileTypeName">
                  <el-input v-model="detailForm.pileTypeName" clearable placeholder="请输入充电桩型号" size="small"
                    maxlength="25"></el-input>
                </el-form-item>
                <el-form-item class="detail-from-input" label="规格" prop="specificationName">
                  <el-input v-model="detailForm.specificationName" clearable placeholder="请输入规格" size="small"
                    maxlength="25"></el-input>
                </el-form-item>
              </div>
              <div class="flex">
                <el-form-item class="detail-from-input" label="存货大类名称">
                  <el-input v-model="detailForm.bigName" clearable placeholder="请输入存货大类名称" size="small"
                    maxlength="25"></el-input>
                </el-form-item>
                <el-form-item class="detail-from-input" label="成品料号" prop="materialNo">
                  <el-input v-model="detailForm.materialNo" :disabled='editFlag' clearable placeholder="请输入成品料号"
                    size="small"></el-input>
                </el-form-item>
                <el-form-item class="detail-from-input" label="厂家标识" prop="manufactorId">
                  <el-input v-model="detailForm.manufactorId" clearable placeholder="请输入成品料号" size="small"></el-input>
                </el-form-item>
              </div>
              <div class="flex">
                <!-- <el-form-item class="detail-from-input" label="厂家编码" prop="manufactorCode">
                                        <el-input v-model="detailForm.manufactorCode" clearable placeholder="请输入成品料号" size="small"></el-input>
                                    </el-form-item> -->
                <el-form-item class="detail-from-input" label="业务归属" prop="businessBelong">
                  <el-select ref="businessBelong" @change="changeSelect('businessBelong')" class="full-width"
                    size="small" v-model="detailForm.businessBelong" clearable :disabled='editFlag' placeholder="请选择">
                    <el-option label="电商" value="01"></el-option>
                    <el-option label="非电商" value="02"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item class="detail-from-input" label="版本类型" prop="pileVersionNo">
                  <el-select class="full-width" size="small" v-model="detailForm.pileVersionNo"
                    @change="changeVersionNo" clearable placeholder="请选择">
                    <el-option label="1.0" value="1"></el-option>
                    <el-option label="2.0" value="2"></el-option>
                    <el-option label="3.0" value="3"></el-option>
                    <el-option :disabled="disabledVersion" label="无版本" value="0"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item class="detail-from-input" label="充电桩类型" prop="chargingPileType">
                  <el-select class="full-width" size="small" v-model="detailForm.chargingPileType" placeholder="请选择">
                    <el-option label="壁挂式" value="WALL_MOUNTED"></el-option>
                    <el-option label="便携式" value="PORTABLE"></el-option>
                    <el-option label="五菱桩" value="WULING"></el-option>
                  </el-select>
                </el-form-item>
              </div>
              <div class="flex">
                <el-form-item class="detail-from-input" label="嵌入式版本号" prop="softVersion">
                  <el-input v-model="detailForm.softVersion" :disabled="editFlag" clearable size="small"
                    placeholder="请输入嵌入式版本号" maxlength="200"></el-input>
                </el-form-item>
                <div class="param-grid-col-placeholder" aria-hidden="true"></div>
                <div class="param-grid-col-placeholder" aria-hidden="true"></div>
              </div>
              <el-divider></el-divider>

            </div>
            <div class="margin-bt-10">
              <div class="detail-body-title">参数信息</div>
              <div class="flex">
                <el-form-item class="detail-from-input" label="额定电流(A)" prop="ratedCurrent">
                  <el-input v-model="detailForm.ratedCurrent" clearable placeholder="请输入额定电流" size="small"
                    maxlength="25"></el-input>
                </el-form-item>
                <el-form-item class="detail-from-input" label="额定电压(V)" prop="ratedVoltage">
                  <el-input v-model="detailForm.ratedVoltage" clearable placeholder="请输入额定电压" size="small"
                    maxlength="25"></el-input>
                </el-form-item>
                <el-form-item class="detail-from-input" label="额定功率(kW)" prop="ratedPower">
                  <el-input v-model="detailForm.ratedPower" clearable placeholder="请输入额定功率" size="small"
                    maxlength="25"></el-input>
                </el-form-item>
              </div>
              <div class="flex">
                <el-form-item class="detail-from-input" label="单项桩/三项桩" prop="phaseType">
                  <el-select ref="phaseType" @change="changeSelect('phaseType')" class="full-width" size="small"
                    v-model="detailForm.phaseType" clearable placeholder="请选择">
                    <el-option label="单项" value="01"></el-option>
                    <el-option label="三项" value="02"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item class="detail-from-input" label="充电枪数量" prop="gunNum">
                  <el-input v-model="detailForm.gunNum" clearable placeholder="请输入充电枪数量" size="small"
                    maxlength="25"></el-input>
                </el-form-item>
                <el-form-item class="detail-from-input" label="充电速度" prop="chargingSpeed">
                  <el-select ref="chargingSpeed" @change="changeSelect('chargingSpeed')" class="full-width" size="small"
                    v-model="detailForm.chargingSpeed" clearable placeholder="请选择">
                    <el-option label="快充" value="01"></el-option>
                    <el-option label="慢充" value="02"></el-option>
                  </el-select>
                </el-form-item>
              </div>
              <div class="flex">
                <el-form-item class="detail-from-input" label="接口类型" prop="interfaceType">
                  <el-select ref="interfaceType" @change="changeSelect('interfaceType')" class="full-width" size="small"
                    v-model="detailForm.interfaceType" clearable placeholder="请选择">
                    <el-option label="国标" value="01"></el-option>
                    <el-option label="欧标" value="02"></el-option>
                    <el-option label="美标" value="03"></el-option>
                    <el-option label="其他" value="04"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item class="detail-from-input" label="电流输出类型" prop="currentOutType">
                  <el-select ref="currentOutType" @change="changeSelect('currentOutType')" class="full-width"
                    size="small" v-model="detailForm.currentOutType" clearable placeholder="请选择">
                    <el-option label="交流" value="01"></el-option>
                    <el-option label="直流" value="02"></el-option>
                  </el-select>
                </el-form-item>
                <div class="param-grid-col-placeholder" aria-hidden="true"></div>
              </div>
              <el-divider></el-divider>
            </div>
            <div class="margin-bt-10">
              <div class="detail-body-title">设备功能信息</div>
              <div class="flex">
                <el-form-item class="detail-from-input" label="预约充电" prop="hasReservation">
                  <el-select class="full-width" size="small" v-model="detailForm.hasReservation" clearable
                    placeholder="请选择预约充电">
                    <el-option label="有" :value="1"></el-option>
                    <el-option label="无" :value="0"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item class="detail-from-input" label="即插即充" prop="offHandChargingFlag">
                  <el-select class="full-width" size="small" v-model="detailForm.offHandChargingFlag" clearable
                    placeholder="请选择">
                    <el-option label="有" value="Y"></el-option>
                    <el-option label="无" value="N"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item class="detail-from-input" label="无感充电" prop="cardFlag">
                  <el-select class="full-width" size="small" v-model="detailForm.cardFlag" clearable placeholder="请选择">
                    <el-option label="有" value="Y"></el-option>
                    <el-option label="无" value="N"></el-option>
                  </el-select>
                </el-form-item>
              </div>
              <div class="flex">
                <el-form-item class="detail-from-input" label="音频" prop="audioType">
                  <el-select ref="audioType" @change="changeSelect('audioType')" class="full-width" size="small"
                    v-model="detailForm.audioType" clearable placeholder="请选择">
                    <el-option label="无" value="00"></el-option>
                    <el-option label="蜂鸣器" value="01"></el-option>
                    <el-option label="扬声器" value="02"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item class="detail-from-input" label="联网方式" prop="networkStatus">
                  <el-select ref="networkStatus" @change="changeSelect('networkStatus')" class="full-width" size="small"
                    v-model="detailForm.networkStatus" clearable placeholder="请选择">
                    <el-option label="4G" value="01"></el-option>
                    <el-option label="4G+WIFI" value="02"></el-option>
                    <el-option label="无" value="03"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item class="detail-from-input" label="蓝牙功能" prop="bluetoothFlag">
                  <el-select class="full-width" size="small" v-model="detailForm.bluetoothFlag" clearable
                    placeholder="请选择">
                    <el-option label="有" value="Y"></el-option>
                    <el-option label="无" value="N"></el-option>
                  </el-select>
                </el-form-item>
              </div>
              <div class="flex">
                <el-form-item class="detail-from-input" label="蓝牙配置" prop="bluetoothPairFlag">
                  <el-select class="full-width" size="small" v-model="detailForm.bluetoothPairFlag" clearable
                    placeholder="请选择">
                    <el-option label="新协议" value="Y"></el-option>
                    <el-option label="老协议" value="N"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item class="detail-from-input" label="蚂蚁森林能量发放" prop="isGreenEnergy">
                  <el-select class="full-width" size="small" v-model="detailForm.isGreenEnergy" clearable
                    placeholder="请选择">
                    <el-option label="可以" value="Y"></el-option>
                    <el-option label="不可以" value="N"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item class="detail-from-input" label="是否支持智能充电" prop="adjustPower">
                  <el-select class="full-width" size="small" v-model="detailForm.adjustPower" clearable
                    placeholder="请选择">
                    <el-option label="是" value="1"></el-option>
                    <el-option label="否" value="0"></el-option>
                    <el-option label="OTA升级支持" value="2"></el-option>
                  </el-select>
                </el-form-item>
              </div>
              <div class="flex">
                <el-form-item class="detail-from-input" label="是否参与活动" prop="isActivity">
                  <el-select class="full-width" size="small" v-model="detailForm.isActivity" clearable
                    placeholder="请选择">
                    <el-option label="参加" value="Y"></el-option>
                    <el-option label="不参加" value="N"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item class="detail-from-input" label="是否带屏桩" prop="isScreen">
                  <el-select class="full-width" size="small" v-model="detailForm.isScreen" clearable placeholder="请选择">
                    <el-option label="全部支持" value="1"></el-option>
                    <el-option label="不支持" value="2"></el-option>
                    <el-option label="休眠方式设置" value="3"></el-option>
                    <el-option label="显示模式设置" value="4"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item class="detail-from-input" label="电流调节" prop="hasCurrentAdjustable">
                  <el-select class="full-width" size="small" v-model="detailForm.hasCurrentAdjustable" clearable
                    placeholder="请选择电流调节">
                    <el-option label="是" :value="1"></el-option>
                    <el-option label="否" :value="0"></el-option>
                  </el-select>
                </el-form-item>
              </div>
              <div class="flex">
                <el-form-item class="detail-from-input" label="亲友共享" prop="hasFamilySharing">
                  <el-select class="full-width" size="small" v-model="detailForm.hasFamilySharing" clearable
                    placeholder="请选择亲友共享">
                    <el-option label="是" :value="1"></el-option>
                    <el-option label="否" :value="0"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item class="detail-from-input" label="充电闹钟" prop="hasChargingAlarm">
                  <el-select class="full-width" size="small" v-model="detailForm.hasChargingAlarm" clearable
                    placeholder="请选择充电闹钟">
                    <el-option label="是" :value="1"></el-option>
                    <el-option label="否" :value="0"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item class="detail-from-input" label="设备升级" prop="upgradeMethod">
                  <el-select class="full-width" size="small" v-model="detailForm.upgradeMethod" clearable
                    placeholder="请选择设备升级">
                    <el-option label="在线+离线升级" :value="3"></el-option>
                    <el-option label="离线升级" :value="2"></el-option>
                    <el-option label="在线升级" :value="1"></el-option>
                    <el-option label="不支持升级" :value="0"></el-option>
                  </el-select>
                </el-form-item>
              </div>

              <div class="flex">
                <el-form-item class="detail-from-input" label="国际兼容设置" prop="hasNationalStandardCompatibility">
                  <el-select class="full-width" size="small" v-model="detailForm.hasNationalStandardCompatibility"
                    clearable placeholder="请选择国际兼容设置">
                    <el-option label="无" :value="0" />
                    <el-option label="二极管" :value="1" />
                    <el-option label="cp" :value="2" />
                    <el-option label="全部" :value="99" />
                  </el-select>
                </el-form-item>
                <el-form-item class="detail-from-input" label="参与活动类型" prop="activityType">
                  <el-select class="full-width" size="small" v-model="detailForm.activityType" clearable
                    placeholder="请选择参与活动类型">
                    <el-option label="不参与活动" :value="0"></el-option>
                    <el-option label="订阅活动" :value="2"></el-option>
                    <el-option label="桩主联盟活动" :value="1"></el-option>
                    <el-option label="家庭充电超级服务包" :value="3"></el-option>
                    <el-option label="送桩活动" :value="4"></el-option>
                    <el-option label="安心包活动" :value="5"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item class="detail-from-input" label="是否支持刷卡" prop="hasCardSwipingSupported">
                  <el-select class="full-width" size="small" v-model="detailForm.hasCardSwipingSupported" clearable
                    placeholder="请选择是否支持刷卡">
                    <el-option label="支持" :value="1"></el-option>
                    <el-option label="不支持" :value="0"></el-option>
                  </el-select>
                </el-form-item>
              </div>

              <div class="flex">
                <el-form-item class="detail-from-input" label="私桩共享" prop="hasPrivatePileSharing">
                  <el-select class="full-width" size="small" v-model="detailForm.hasPrivatePileSharing" clearable
                    placeholder="请选择私桩共享">
                    <el-option label="有" :value="1"></el-option>
                    <el-option label="无" :value="0"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item class="detail-from-input" label="是否支持三插头温控" prop="hasThreePinThermalControl">
                  <el-select class="full-width" size="small" v-model="detailForm.hasThreePinThermalControl"
                    placeholder="请选择">
                    <el-option label="不支持" :value="0"></el-option>
                    <el-option label="支持" :value="1"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item class="detail-from-input" label="是否支持转换头识别" prop="adapterRecognition">
                  <el-select class="full-width" size="small" v-model="detailForm.adapterRecognition" placeholder="请选择">
                    <el-option label="不支持" :value="0"></el-option>
                    <el-option label="支持" :value="1"></el-option>
                  </el-select>
                </el-form-item>
              </div>
              <div class="flex">
                <el-form-item class="detail-from-input" label="倒计时预约" prop="countdownReservation">
                  <el-select class="full-width" size="small" v-model="detailForm.countdownReservation" placeholder="请选择"
                    @change="onCountdownReservationChange">
                    <el-option label="不支持" :value="0"></el-option>
                    <el-option label="支持" :value="1"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item class="detail-from-input" label="电流设置记忆" prop="currentSettingMemory">
                  <el-select class="full-width" size="small" v-model="detailForm.currentSettingMemory" placeholder="请选择"
                    @change="onCurrentSettingMemoryChange">
                    <el-option label="不支持" :value="0"></el-option>
                    <el-option label="支持" :value="1"></el-option>
                  </el-select>
                </el-form-item>
              </div>

              <el-divider></el-divider>

              <!-- 设备功能信息=其他嵌入式版本  -->
              <div class="flex" style="align-items: center; justify-content: space-between; margin-top: 8px;">
                <div class="detail-body-title" style="margin-bottom: 0;">设备功能信息-其他嵌入式版本</div>
                <el-tooltip content="请先保存信息" placement="top" :disabled="editFlag">
                  <span style="display: inline-block;">
                    <el-button type="primary" size="small" :disabled="!editFlag"
                      @click="goAddEmbeddedVersion">新增版本</el-button>
                  </span>
                </el-tooltip>
              </div>
              <el-table class="detail-table" :data="embeddedVersionTableData" border
                :header-cell-style="{ background: '#FAFAFA', color: '#8F9BB3', fontSize: '14px' }">
                <el-table-column type="selection" width="48" align="center"></el-table-column>
                <el-table-column prop="softVersion" label="嵌入式版本号" min-width="120"
                  show-overflow-tooltip></el-table-column>
                <el-table-column label="是否为默认版本" width="130" align="center">
                  <template slot-scope="scope">
                    {{ scope.row.defaultFlag === 1 || scope.row.defaultFlag === '1' ? '是' : '否' }}
                  </template>
                </el-table-column>
                <el-table-column prop="createdWhen" label="创建时间" width="170" align="center"></el-table-column>
                <el-table-column label="状态" width="200" align="center">
                  <template slot-scope="scope">
                    <el-radio-group v-model="scope.row.status" size="mini" :disabled="!editFlag"
                      @change="(val) => onEmbeddedVersionStatusChange(scope.row, val)">
                      <el-radio :label="0">启用</el-radio>
                      <el-radio :label="1">禁用</el-radio>
                    </el-radio-group>
                  </template>
                </el-table-column>
                <el-table-column label="操作" width="100" align="center" fixed="right">
                  <template slot-scope="scope">
                    <el-button type="text" @click="goDetailEmbeddedVersion(scope.$index)">详情</el-button>
                  </template>
                </el-table-column>
              </el-table>

            </div>
            <div class="margin-bt-10">
              <div class="detail-body-title">物联网卡及质保信息</div>
              <div class="flex">
                <el-form-item class="detail-from-input" label="质保赠送时间" prop="warrantyTimeStatus">
                  <el-select ref="warrantyTimeStatus" @change="changeSelect('warrantyTimeStatus')" class="full-width"
                    size="small" v-model="detailForm.warrantyTimeStatus" clearable placeholder="请选择">
                    <el-option label="2年" value="01"></el-option>
                    <el-option label="4年" value="04"></el-option>
                    <!-- value 不能是空字符串，否则必填校验会当成“未选择” -->
                    <el-option label="无期限" value="00"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item class="detail-from-input" label="流量赠送时间" prop="networkTimeStatus">
                  <el-select ref="networkTimeStatus" @change="changeSelect('networkTimeStatus')" class="full-width"
                    size="small" v-model="detailForm.networkTimeStatus" clearable>
                    <el-option label="1年" value="01"></el-option>
                    <el-option label="2年" value="02"></el-option>
                    <el-option label="5年" value="03"></el-option>
                    <el-option label="10年" value="04"></el-option>
                    <el-option label="无期限" value="05"></el-option>
                  </el-select>
                </el-form-item>
              </div>

              <el-divider></el-divider>

            </div>
            <div class="margin-bt-10 logo-status-footer">
              <el-form-item class="detail-form-logo-row" label="充电桩图片" label-width="100px">
                <div class="pile-img-picker">
                  <div class="pile-img-box" @click="openImgLib">
                    <img v-if="detailForm.pileImgUrl" :src="detailForm.pileImgUrl" alt="充电桩图片" class="pile-img" />
                    <i v-else class="el-icon-plus"></i>
                    <div class="pile-img-mask">
                      <span class="pile-img-mask-edit" v-if="detailForm.pileImgUrl"><i class="el-icon-edit"></i> 更换</span>
                      <span v-else><i class="el-icon-picture-outline"></i> 选择图片</span>
                      <span class="pile-img-mask-del" v-if="detailForm.pileImgUrl" @click.stop="handleLogoRemove"><i
                          class="el-icon-delete"></i> 删除</span>
                    </div>
                  </div>
                  <div class="pile-img-side">
                    <el-button size="small" type="primary" plain icon="el-icon-picture-outline"
                      @click="openImgLib">从图库选择</el-button>
                    <div class="el-upload__tip">支持 jpg / jpeg / bmp / gif / png（仅1张，不超过1M），可在弹框中上传新图片到图库</div>
                  </div>
                </div>
              </el-form-item>
              <el-form-item class="detail-form-status-row detail-from-input" label="状态" label-width="72px"
                prop="status">
                <el-radio-group v-model="detailForm.status" :disabled='!editFlag'>
                  <el-radio label="Y">启用</el-radio>
                  <el-radio label="N">禁用</el-radio>
                </el-radio-group>
              </el-form-item>
            </div>


          </div>
        </el-form>

      </div>
      <!-- 桩图片库弹框：选择/新增图片（s_config type=400） -->
      <el-dialog title="桩图片库" :visible.sync="imgLibVisible" width="780px" append-to-body
        custom-class="img-lib-dialog">
        <div class="img-lib-upload-bar">
          <div class="img-lib-upload-tip"><i class="el-icon-info"></i>
            {{ libEditMode ? '编辑模式：点击图片选中要删除的图片，一次只能删除一张' : '点击图片即可回填，可上传新图片到图库' }}</div>
          <div class="img-lib-upload-oper">
            <el-input v-model="imgSearchName" placeholder="请输入图片名称搜索" size="small" class="img-lib-name-input"
              clearable></el-input>
            <el-button size="small" type="primary" icon="el-icon-upload2"
              @click="openUploadLibDialog">上传新图片</el-button>
            <el-button size="small" :type="libEditMode ? 'warning' : ''" icon="el-icon-edit"
              @click="toggleLibEditMode">{{ libEditMode ? '退出编辑' : '编 辑' }}</el-button>
          </div>
        </div>
        <div class="img-lib-grid" v-loading="imgLibLoading">
          <div v-for="item in filteredImgLibList" :key="item.id" class="img-lib-item"
            :class="{ active: libEditMode ? item.id === (libDelItem && libDelItem.id) : item.configVal === selectedLibImg }"
            @click="selectLibImg(item)">
            <img :src="item.configVal" :alt="item.configName" />
            <div class="img-lib-name" :title="item.configName">{{ item.configName }}</div>
            <i class="el-icon-zoom-in img-lib-preview-btn" title="预览大图"
              @click.stop="previewLibImg(item.configVal)"></i>
            <i class="el-icon-success img-lib-check"></i>
          </div>
          <div v-if="!filteredImgLibList.length && !imgLibLoading" class="img-lib-empty">
            <i class="el-icon-picture-outline"></i>
            <p>{{ imgLibList.length ? '未找到匹配的图片' : '图库为空，请先上传图片' }}</p>
          </div>
        </div>
        <div slot="footer" class="img-lib-footer">
          <el-button size="small" @click="imgLibVisible = false">取 消</el-button>
          <el-button v-if="!libEditMode" size="small" type="primary" @click="confirmChooseImg">确 定</el-button>
          <el-button v-else size="small" type="danger" :loading="libDeleting"
            @click="confirmDeleteLibImg">删 除</el-button>
        </div>
      </el-dialog>
      <!-- 上传新图片到图库弹框 -->
      <el-dialog title="上传新图片" :visible.sync="uploadLibVisible" width="420px" append-to-body
        custom-class="img-lib-upload-dialog">
        <el-form label-width="80px" size="small">
          <el-form-item label="图片名称" required>
            <el-input v-model="addImgName" placeholder="请输入图片名称" maxlength="20" clearable></el-input>
          </el-form-item>
          <el-form-item label="选择图片" required>
            <el-upload action="" :show-file-list="false" :auto-upload="false" :on-change="handleLibFileChange"
              accept="image/jpeg,image/png,image/bmp,image/gif">
              <el-button size="small" icon="el-icon-folder-opened">选择文件</el-button>
            </el-upload>
            <div v-if="uploadLibFile" class="img-lib-file-info">
              <img :src="uploadLibFile.url" class="img-lib-file-thumb" />
              <span class="img-lib-file-name">{{ uploadLibFile.name }}</span>
            </div>
            <div class="img-lib-upload-tip-text">支持 jpg / jpeg / bmp / gif / png，不超过1M</div>
          </el-form-item>
        </el-form>
        <div slot="footer">
          <el-button size="small" @click="uploadLibVisible = false">取 消</el-button>
          <el-button size="small" type="primary" :loading="uploadLibSubmitting"
            @click="confirmUploadLibImg">确 定</el-button>
        </div>
      </el-dialog>
      <!-- 图库图片大图预览弹框 -->
      <el-dialog title="图片预览" :visible.sync="libPreviewVisible" width="520px" append-to-body
        custom-class="img-lib-preview-dialog">
        <img :src="libPreviewUrl" class="img-lib-preview-img" alt="图片预览" />
      </el-dialog>
      <div class="detail-content-footer-div">
        <button class="common-bg-button" @click="submitForm('detailForm')">提 交</button>
        <button class="common-empty-button" @click="resetForm">取 消</button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import config from '@/config/config';
import pageConfig, { validateEmbeddedSoftVersionPrefix } from './page-config';
import { buildMainSubPayloadForDetailSubmit } from './pile-function-payload';

/** 仅表格状态接口：解析业务错误文案（与接口字段 msg、messageList、errList 一致） */
function pickPileTypeVersionEditErrorMessage(data) {
  if (!data || typeof data !== 'object') return '';
  if (data.msg != null && String(data.msg).trim() !== '') return String(data.msg);
  const pickFromArr = (arr) => {
    if (!Array.isArray(arr) || !arr.length || !arr[0]) return '';
    const o = arr[0];
    return String(
      o.messageBody || o.messageSubject || o.messageForDeveloper || o.messageId || ''
    );
  };
  const fromErr = pickFromArr(data.errList);
  if (fromErr) return fromErr;
  const fromMsgList = pickFromArr(data.messageList);
  if (fromMsgList) return fromMsgList;
  return '';
}

function createEmptyDetailForm() {
  return {
    pileTypeNo: '',
    pileVersionNo: '1',
    hasThreePinThermalControl: 0,
    adapterRecognition: 0,
    chargingPileType: 'WALL_MOUNTED',
    PileFunctionEntity: {},
    piletypeEntity: {},
    status: 'Y',
    adjustPower: '',
    isScreen: null,
    hasReservation: '',
    hasCurrentAdjustable: '',
    hasFamilySharing: '',
    hasChargingAlarm: '',
    upgradeMethod: '',
    hasNationalStandardCompatibility: '',
    activityType: '',
    hasCardSwipingSupported: '',
    hasPrivatePileSharing: '',
    softVersion: '',
    // 与 el-option :value="0|1" 保持数字类型一致，避免严格相等不匹配导致下拉无法选中
    countdownReservation: 0,
    currentSettingMemory: 0,
  };
}

export default {
  data() {
    return {
      pageConfig,
      editFlag: false, //表单是否编辑状态
      disabledVersion: true,
      pageTitle: '充电桩基础信息管理',
      pileVersionNo: '1',
      // 默认值设置
      detailForm: createEmptyDetailForm(),
      stationDetailForm: {}, //电站编号
      logoFile: null, //logo图标
      logoFileList: [], //logo预览文件
      dialogVisible: false, //app卡包样式弹窗
      selectFlag: '', //选中的卡包样式
      stationTableData: [], //绑定电站数据
      contractFile: null, //上传文件
      fileList: [], //上传文件预览地址
      dealerBankDtoList: [], //运营商收款账户数据
      dealerFileDtoList: [], //运营商table表单数据
      radio: '', //收款账号是否启用
      url: '', //请求数据的url地址
      ruleArr: [], //表单验证字段
      imgArr: [], //卡包样式数据列表
      fileRadio: '', //合同是否启用
      /** 对应接口 pileTypeVersionEntityList；status：0 启用 1 禁用；defaultFlag：1 默认版本 */
      embeddedVersionTableData: [],
      imgLibVisible: false, //桩图片库弹框
      imgLibLoading: false, //图库加载中
      imgLibList: [], //桩图片库列表（s_config type=400）
      selectedLibImg: '', //弹框中选中的图片URL
      addImgName: '', //新增图片名称（上传弹窗内填写）
      imgSearchName: '', //图库搜索关键字（纯前端过滤）
      uploadLibVisible: false, //上传新图片弹框
      uploadLibFile: null, //上传弹框选中的文件 {file, url, name}
      uploadLibSubmitting: false, //上传防重
      libPreviewVisible: false, //图库图片预览弹框
      libPreviewUrl: '', //预览的图片URL
      libEditMode: false, //图库编辑模式（选择图片删除）
      libDelItem: null, //编辑模式选中的待删除图片项
      libDeleting: false, //删除防重
    }
  },
  computed: {
    /** 图库按名称前端过滤 */
    filteredImgLibList() {
      const keyword = (this.imgSearchName || '').trim().toLowerCase();
      if (!keyword) {
        return this.imgLibList;
      }
      return this.imgLibList.filter(e => (e.configName || '').toLowerCase().includes(keyword));
    },
    /** 编辑态允许「无版本」(pileVersionNo=0)，与接口一致；新增仍禁止选无版本 */
    detailFormRules() {
      const base = pageConfig.formRules || {};
      const appendRule = (name, rule) => {
        const source = Array.isArray(base[name]) ? [...base[name]] : [];
        source.push(rule);
        return source;
      };
      const createNumericValidator = (label, allowDecimal = true) => ({
        validator: (rule, value, callback) => {
          const str = value === undefined || value === null ? '' : String(value).trim();
          if (!str) {
            callback();
            return;
          }
          const reg = allowDecimal ? /^(?:0|[1-9]\d*)(?:\.\d+)?$/ : /^(?:0|[1-9]\d*)$/;
          if (!reg.test(str)) {
            callback(new Error(`${label}仅支持数字输入`));
            return;
          }
          callback();
        },
        trigger: 'blur',
      });
      const pileVersionNoBase = Array.isArray(base.pileVersionNo) ? [...base.pileVersionNo] : [];
      pileVersionNoBase.push({
        validator: (rule, value, callback) => {
          if (!this.editFlag && (value === '0' || value === 0)) {
            callback(new Error('当前无版本'));
          } else {
            callback();
          }
        },
        trigger: 'change',
      });
      return {
        ...base,
        pileVersionNo: pileVersionNoBase,
        ratedCurrent: appendRule('ratedCurrent', createNumericValidator('额定电流')),
        ratedVoltage: appendRule('ratedVoltage', createNumericValidator('额定电压')),
        ratedPower: appendRule('ratedPower', createNumericValidator('额定功率')),
        gunNum: appendRule('gunNum', createNumericValidator('充电枪数量', false)),
        softVersion: this.editFlag
          ? []
          : [
              {
                required: true,
                message: '请输入嵌入式版本号',
                trigger: ['blur', 'change'],
              },
              {
                validator: (rule, value, callback) =>
                  validateEmbeddedSoftVersionPrefix(rule, value, callback),
                trigger: 'blur',
              },
            ],
      };
    },
  },
  methods: {
    onCountdownReservationChange(val) {
      this.$set(this.detailForm, 'countdownReservation', val);
    },
    onCurrentSettingMemoryChange(val) {
      this.$set(this.detailForm, 'currentSettingMemory', val);
    },
    changeVersionNo(val) {
      this.detailForm.pileVersionNo = val
    },
    //是否为编辑模式   
    init() {
      // this.url = this.$A.dealer.add;
      // if(this.$store.state.editId){this
      //     this.editFlag = true;
      //     this.pageTitle = "运营商编辑";
      //     this.getFormInfo();
      //     this.url = this.$A.dealer.edit;
      //     this.ruleArr = this.pageConfig.editRuleArr;
      //     this.getConfig();
      // }else{
      //     this.ruleArr = this.pageConfig.addRuleArr;
      // }
      if (this.$route.query.pileTypeNo) {
        this.editFlag = true;
        this.detailForm.pileTypeNo = this.$route.query.pileTypeNo
        pageConfig.detailBreadCrumb[3].name = "编辑";
        this.getFormInfo();
        // console.log(this.detailForm.pileVersionNo);

        this.url = this.$A.digitization.pileFunctionEdit;
      } else {
        this.editFlag = false;
        pageConfig.detailBreadCrumb[3].name = "新增";
        this.detailForm.pileVersionNo = '1'
        this.pileVersionNo = '1'
        this.url = '';
        if (this.$route.query.fromEmbedded === '1') {
          this.restoreParentDetailFromCache();
          this.applyEmbeddedListFromCache();
        } else {
          this.detailForm = createEmptyDetailForm();
          this.embeddedVersionTableData = [];
          this.logoFileList = [];
        }
        this.$nextTick(() => {
          if (this.$refs.detailForm) this.$refs.detailForm.clearValidate();
        });
      }
    },
    embeddedStorageKey(pileTypeNo) {
      return 'chargingPile_embedded_list_' + (pileTypeNo || '__new__');
    },
    syncEmbeddedListToSession() {
      const pileNo = this.detailForm.pileTypeNo || '';
      sessionStorage.setItem(
        this.embeddedStorageKey(pileNo),
        JSON.stringify(this.embeddedVersionTableData)
      );
    },
    /** 供嵌入式子页与 savePileVersion 合并完整主表快照 */
    syncParentDetailForEmbeddedSession() {
      const pileNo = this.detailForm.pileTypeNo || '';
      try {
        sessionStorage.setItem(
          'chargingPile_parent_detail_' + (pileNo || '__new__'),
          JSON.stringify(this.detailForm)
        );
      } catch (e) {
        console.warn(e);
      }
    },
    restoreParentDetailFromCache() {
      const pileNo = this.detailForm.pileTypeNo || this.$route.query.pileTypeNo || '';
      const key = 'chargingPile_parent_detail_' + (pileNo || '__new__');
      const raw = sessionStorage.getItem(key);
      if (!raw) return;
      try {
        const obj = JSON.parse(raw);
        if (obj && typeof obj === 'object') {
          this.detailForm = Object.assign({}, this.detailForm, obj);
        }
      } catch (e) {
        console.warn(e);
      }
    },
    goAddEmbeddedVersion() {
      if (!this.editFlag) return;
      this.syncEmbeddedListToSession();
      // 进入子页前写入当前页主表快照，供子页预填（与点击时刻详情表单一致，非历史草稿）
      this.syncParentDetailForEmbeddedSession();
      const q = { mode: 'add' };
      if (this.detailForm.pileTypeNo) q.pileTypeNo = this.detailForm.pileTypeNo;
      this.$router.push({ name: 'ChargingPileEmbeddedVersion', query: q });
    },
    goDetailEmbeddedVersion(index) {
      this.syncEmbeddedListToSession();
      this.syncParentDetailForEmbeddedSession();
      const row = this.embeddedVersionTableData && this.embeddedVersionTableData[index];
      if (!row) {
        this.$U.error('行数据不存在');
        return;
      }
      // findByFunctionId 的 functionId：必须是当前行 pileTypeVersionEntityList 的 pileFunctionId（非主表根 functionId）
      const rowFunctionId = row.pileFunctionId || row.functionId || '';
      if (!rowFunctionId) {
        this.$U.error('缺少该版本 pileFunctionId，无法打开详情');
        return;
      }
      const q = {
        mode: 'edit',
        index: String(index),
        functionId: rowFunctionId,
        pileFunctionId: rowFunctionId,
        pileTypeNo: row.pileTypeNo || this.detailForm.pileTypeNo || '',
      };
      if (row.pileTypeVersionId) q.pileTypeVersionId = row.pileTypeVersionId;
      this.$router.push({ name: 'ChargingPileEmbeddedVersion', query: q });
    },
    /** 其他嵌入式版本表格：启用/禁用 → /pileTypeVersion/edit，status 0 启用 1 禁用 */
    onEmbeddedVersionStatusChange(row, newStatus) {
      const status = newStatus === 1 || newStatus === '1' ? 1 : 0;
      const prevStatus = status === 0 ? 1 : 0;

      const pileFunctionId = (row && (row.pileFunctionId || row.functionId)) || '';
      const pileTypeNo = (row && row.pileTypeNo) || this.detailForm.pileTypeNo || '';

      if (!this.editFlag) {
        this.$set(row, 'status', prevStatus);
        return;
      }
      if (!pileFunctionId || !pileTypeNo) {
        this.$U.error('缺少 pileFunctionId 或 pileTypeNo，无法修改状态');
        this.$set(row, 'status', prevStatus);
        return;
      }

      const actionText = status === 0 ? '启用' : '禁用';
      this.$confirm(`确定将该嵌入式版本状态修改为「${actionText}」吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() =>
          axios.post(
            this.$A.digitization.pileTypeVersionEdit,
            { pileFunctionId, pileTypeNo, status },
            {
              headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                authorization: this.$store.state.token,
              },
              timeout: config.httpTimeOut,
            }
          )
        )
        .then((axiosRes) => {
          const data = axiosRes && axiosRes.data;
          if (data && data.status == 200) {
            this.$U.success('状态已更新');
            this.syncEmbeddedListToSession();
            return;
          }
          const msg = pickPileTypeVersionEditErrorMessage(data);
          this.$U.error(msg || '状态更新失败');
          this.$set(row, 'status', prevStatus);
        })
        .catch((err) => {
          this.$set(row, 'status', prevStatus);
          if (err === 'cancel') return;
          const data = err && err.response && err.response.data;
          const apiMsg = pickPileTypeVersionEditErrorMessage(data);
          this.$U.error(apiMsg || '请求失败，请重试');
        });
    },
    normalizePileTypeVersionRows(list) {
      if (!Array.isArray(list)) return [];
      return list.map((row) => ({
        ...row,
        status: row.status === 1 || row.status === '1' ? 1 : 0,
        defaultFlag: row.defaultFlag === 1 || row.defaultFlag === '1' ? 1 : 0,
      }));
    },
    /**
     * 接口（或当前表格中的已落库行）与 session 中未落库草稿合并；草稿无 pileTypeVersionId，
     * 与同 softVersion 的接口行去重，避免重复行。
     */
    mergeSessionDraftsIntoEmbeddedTable(apiRows, pileTypeNo) {
      const apiNorm = this.normalizePileTypeVersionRows(Array.isArray(apiRows) ? apiRows : []);
      let cached = [];
      try {
        const raw = sessionStorage.getItem(this.embeddedStorageKey(pileTypeNo || ''));
        if (raw) {
          const parsed = JSON.parse(raw);
          cached = Array.isArray(parsed) ? parsed : [];
        }
      } catch (e) {
        cached = [];
      }
      const cachedNorm = this.normalizePileTypeVersionRows(cached);
      const apiSoft = new Set(
        apiNorm
          .map((r) => (r && r.softVersion != null ? String(r.softVersion).trim() : ''))
          .filter((s) => s !== '')
      );
      const drafts = cachedNorm.filter((r) => {
        if (!r) return false;
        if (
          r.pileTypeVersionId !== undefined &&
          r.pileTypeVersionId !== null &&
          String(r.pileTypeVersionId).trim() !== ''
        ) {
          return false;
        }
        const sv = r.softVersion != null ? String(r.softVersion).trim() : '';
        if (sv !== '' && apiSoft.has(sv)) return false;
        return true;
      });
      return apiNorm.concat(drafts);
    },
    /** 从嵌入式子页返回：合并 session 草稿到表格并同步 session，再去掉 URL 参数 */
    applyEmbeddedListFromCache() {
      if (this.$route.query.fromEmbedded !== '1') return;
      const pileNo =
        this.detailForm.pileTypeNo ||
        this.$route.query.pileTypeNo ||
        '';
      this.embeddedVersionTableData = this.mergeSessionDraftsIntoEmbeddedTable(
        this.embeddedVersionTableData || [],
        pileNo
      );
      try {
        sessionStorage.setItem(
          this.embeddedStorageKey(pileNo),
          JSON.stringify(this.embeddedVersionTableData)
        );
      } catch (e) {
        console.warn(e);
      }
      this.stripEmbeddedReturnQuery();
    },
    /** 从嵌入式子页返回时去掉 URL 标记（列表已与 session 草稿合并在 applyEmbeddedListFromCache / getFormInfo 中处理） */
    stripEmbeddedReturnQuery() {
      if (this.$route.query.fromEmbedded !== '1') return;
      const q = { ...this.$route.query };
      delete q.fromEmbedded;
      this.$nextTick(() => {
        this.$router.replace({ name: 'ChargingPileDetail', query: q });
      });
    },
    // 获取表单信息
    getFormInfo() {
      let _ = this;
      _.$H.post(_, _.$A.digitization.findPileFunctionByNo, { pileTypeNo: _.detailForm.pileTypeNo }).then((res) => {
        _.detailForm = res.data.data;
        const pv = _.detailForm.pileVersionNo;
        if (pv === undefined || pv === null || pv === '') {
          _.detailForm.pileVersionNo = '1';
        } else {
          _.detailForm.pileVersionNo = String(pv);
        }
        // 后端可能返回 null，避免拼接成字符串 "null" 导致下拉框一直显示 null
        if (
          _.detailForm.adjustPower === null ||
          _.detailForm.adjustPower === undefined ||
          _.detailForm.adjustPower === '' ||
          _.detailForm.adjustPower === 'null'
        ) {
          _.detailForm.adjustPower = ''
        } else if (_.detailForm.adjustPower === 0 || _.detailForm.adjustPower === '0') {
          _.detailForm.adjustPower = '0'
        } else {
          _.detailForm.adjustPower = _.detailForm.adjustPower + ''
        }

        if (
          _.detailForm.isScreen === null ||
          _.detailForm.isScreen === undefined ||
          _.detailForm.isScreen === '' ||
          _.detailForm.isScreen === 'null'
        ) {
          _.detailForm.isScreen = ''
        } else {
          _.detailForm.isScreen = _.detailForm.isScreen + ''
        }

        const sanitizeNullToEmpty = (val) => {
          if (val === null || val === undefined || val === '' || val === 'null') return '';
          return val;
        };
        const to01 = (val) => {
          if (val === null || val === undefined || val === '' || val === 'null') return 0;
          const n = Number(val);
          return n === 1 ? 1 : 0;
        };
        // 接口对象可能起初不含这两字段，直接赋值非响应式会导致 el-select 选了不生效，须 $set
        _.$set(
          _.detailForm,
          'countdownReservation',
          to01(_.detailForm.countdownReservation)
        );
        _.$set(
          _.detailForm,
          'currentSettingMemory',
          to01(_.detailForm.currentSettingMemory)
        );
        const rawSv =
          _.detailForm.softVersion !== undefined && _.detailForm.softVersion !== null && _.detailForm.softVersion !== ''
            ? _.detailForm.softVersion
            : _.detailForm.defaultEmbeddedVersionNo;
        if (rawSv === null || rawSv === undefined || rawSv === 'null') {
          _.detailForm.softVersion = '';
        } else {
          _.detailForm.softVersion = String(rawSv);
        }

        // 质保赠送时间：后端可能用空字符串表示“无期限”，前端下拉框用 00 作为有效值避免必填校验误判
        if (_.detailForm.warrantyTimeStatus === '' || _.detailForm.warrantyTimeStatus === null || _.detailForm.warrantyTimeStatus === undefined) {
          _.detailForm.warrantyTimeStatus = '00';
          _.detailForm.warrantyTimeStatusName = _.detailForm.warrantyTimeStatusName || '无期限';
        }

        console.log(_.detailForm)
        const list =
          _.detailForm.pileTypeVersionEntityList ||
          _.detailForm.otherEmbeddedVersionList ||
          [];
        const apiRows = Array.isArray(list) ? [].concat(list) : [];
        _.embeddedVersionTableData = _.mergeSessionDraftsIntoEmbeddedTable(
          apiRows,
          _.detailForm.pileTypeNo || ''
        );
        try {
          sessionStorage.setItem(
            _.embeddedStorageKey(_.detailForm.pileTypeNo || ''),
            JSON.stringify(_.embeddedVersionTableData)
          );
        } catch (e) {
          console.warn(e);
        }
        if (_.$route.query.fromEmbedded === '1') {
          _.stripEmbeddedReturnQuery();
        }
        try {
          sessionStorage.setItem(
            'chargingPile_parent_detail_' + (_.detailForm.pileTypeNo || '__new__'),
            JSON.stringify(_.detailForm)
          );
        } catch (e) {
          console.warn(e);
        }
        _.logoFileList = [];
        if (_.detailForm.pileImgUrl) {
          let imgObj = {}
          imgObj.name = 'pileImg';
          imgObj.url = _.detailForm.pileImgUrl;
          _.logoFileList.push(imgObj);
        }
        // 编辑态异步回填后清理历史校验状态，避免出现“有值仍红框”
        _.$nextTick(() => {
          if (_.$refs.detailForm) _.$refs.detailForm.clearValidate();
        });
      });
    },
    // 表单提交
    submitForm(formName) {
      let _ = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          _.detailForm.businessBelong = '01';
          _.detailForm.businessBelongName = '电商';
          // 提交时不要改动 v-model 绑定的 detailForm（会触发校验红字闪现）；只改 payload 副本
          const submitSnapshot = { ..._.detailForm };
          if (submitSnapshot.warrantyTimeStatus === '00') submitSnapshot.warrantyTimeStatus = '';
          const pilePayload = buildMainSubPayloadForDetailSubmit(submitSnapshot);
          const submitApi = _.editFlag
            ? _.$A.digitization.updatePileVersion
            : _.$A.digitization.savePileVersion;
          _.$H.post(_, submitApi, pilePayload).then(res => {
            if (res.status === 200) {
              try {
                sessionStorage.removeItem(_.embeddedStorageKey(_.detailForm.pileTypeNo || ''));
              } catch (e) {
                console.warn(e);
              }
              _.$U.success(_.editFlag ? "编辑成功！" : "新增成功！");
              _.$router.push({
                name: pageConfig.listRouter
              });
            } else {
              _.$U.error(res.data?.message || (_.editFlag ? "编辑失败，请重试！" : "新增失败，请重试！"));
            }
          }).catch(err => {
            _.$U.error(err?.message || (_.editFlag ? "编辑失败，请重试！" : "新增失败，请重试！"));
          })
        } else {
          _.$U.error("请完善表单信息！");
        }
      })
    },
    changeSelect(val) {
      this.$nextTick(() => {
        console.log(this.$refs[val]);
        this.detailForm[val] = this.$refs[val].selected.value
        this.detailForm[`${val}Name`] = this.$refs[val].selected.label
        console.log(this.detailForm);
        // for (let i = 0; i < arr.length; i++) {
        //     console.log(arr[i].label, i)
        // console.log(arr[i].currentValue, i)
        //     console.log(arr[i].currentLabel, i)
        // }
      })
    },
    //上传logo图片
    toUploadLogoImg(param) {
      this.logoFile = param.file;
    },
    handleLogoRemove(file, fileList) {
      this.detailForm.pileImgUrl = '';
      this.logoFile = null;
    },
    //上传logo图片限制
    beforeAvatarUpload(file) {
      let logoType = false;
      if (file.type === 'image/jpeg' || file.type === 'image/jpg' || file.type === 'image/bmp' || file.type === 'image/gif' || file.type === 'image/png') {
        logoType = true;
      }
      const isLt1M = file.size / 1024 / 1024 < 1;

      if (!logoType) {
        this.$message.error('上传logo图片只能是 jpg / jpeg / bmp / gif / png 格式!');
      }
      if (!isLt1M) {
        this.$message.error('上传logo图片大小不能超过 1MB!');
      }
      return logoType && isLt1M;
    },
    //打开桩图片库弹框
    openImgLib() {
      this.selectedLibImg = this.detailForm.pileImgUrl || '';
      this.imgSearchName = '';
      this.exitLibEditMode();
      this.closeUploadLibDialog();
      this.loadImgLib();
      this.imgLibVisible = true;
    },
    //加载桩图片库（s_config type=400）
    loadImgLib() {
      let _ = this;
      _.imgLibLoading = true;
      _.$H.post(_, _.$A.config.list, { configType: '400' }).then(res => {
        const list = (res.data && res.data.data) || [];
        list.sort((a, b) => Number(a.configDisp || 0) - Number(b.configDisp || 0));
        _.imgLibList = list;
        _.imgLibLoading = false;
      }).catch(() => { _.imgLibLoading = false; })
    },
    //图库中选中图片
    selectLibImg(item) {
      if (this.libEditMode) {
        //编辑模式：点选要删除的图片（单选）
        this.libDelItem = item;
        return;
      }
      this.selectedLibImg = item.configVal;
    },
    //切换图库编辑模式（选择图片删除）
    toggleLibEditMode() {
      if (this.libEditMode) {
        this.exitLibEditMode();
        return;
      }
      this.libEditMode = true;
      this.libDelItem = null;
    },
    //退出图库编辑模式并清空删除选中
    exitLibEditMode() {
      this.libEditMode = false;
      this.libDelItem = null;
      this.libDeleting = false;
    },
    //编辑模式删除选中的图库图片（逻辑删除，被桩使用时后端拒绝）
    confirmDeleteLibImg() {
      let _ = this;
      if (!_.libDelItem || !_.libDelItem.id) {
        _.$U.error("请先选择要删除的图片！");
        return;
      }
      _.$confirm('确定从图库删除该图片吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        _.libDeleting = true;
        // http封装在业务失败(status!=200)或网络异常时promise不会结束、只弹全局错误提示，定时兜底恢复按钮
        setTimeout(() => { _.libDeleting = false; }, 5000);
        _.$H.post(_, _.$A.config.delete, { id: _.libDelItem.id }).then(res => {
          _.libDeleting = false;
          _.$U.success("图片已删除！");
          if (_.selectedLibImg === _.libDelItem.configVal) {
            _.selectedLibImg = '';
          }
          _.exitLibEditMode();
          _.loadImgLib();
        }).catch(() => { _.libDeleting = false; });
      }).catch(() => {});
    },
    //确定选择，回填图片到表单
    confirmChooseImg() {
      if (!this.selectedLibImg) {
        this.$U.error("请先选择图片！");
        return;
      }
      this.applyPileImg(this.selectedLibImg);
      this.imgLibVisible = false;
    },
    //图片回填到表单并刷新预览
    applyPileImg(url) {
      this.detailForm.pileImgUrl = url || '';
      this.logoFileList = url ? [{ name: 'pileImg', url: url }] : [];
    },
    //打开上传新图片弹框
    openUploadLibDialog() {
      this.addImgName = '';
      this.releaseLibPreviewUrl();
      this.uploadLibFile = null;
      this.uploadLibVisible = true;
    },
    //关闭上传新图片弹框并重置
    closeUploadLibDialog() {
      this.addImgName = '';
      this.releaseLibPreviewUrl();
      this.uploadLibFile = null;
      this.uploadLibSubmitting = false;
      this.uploadLibVisible = false;
    },
    //选择待上传图片（校验格式/大小后暂存，不直接上传）
    handleLibFileChange(file) {
      if (!file || !file.raw) {
        return;
      }
      if (!this.beforeAvatarUpload(file.raw)) {
        return;
      }
      this.releaseLibPreviewUrl();
      //本地生成 blob 预览地址，不依赖 el-upload 的 file.url（auto-upload=false 时可能为空）
      this.uploadLibFile = { file: file.raw, url: URL.createObjectURL(file.raw), name: file.name };
    },
    //释放缩略图预览的 blob URL
    releaseLibPreviewUrl() {
      if (this.uploadLibFile && this.uploadLibFile.url && this.uploadLibFile.url.indexOf('blob:') === 0) {
        URL.revokeObjectURL(this.uploadLibFile.url);
      }
    },
    //预览图库图片大图
    previewLibImg(url) {
      this.libPreviewUrl = url;
      this.libPreviewVisible = true;
    },
    //确定上传：图片传文件服务器后写入图片库（s_config type=400），成功后自动选中
    confirmUploadLibImg() {
      let _ = this;
      if (!_.addImgName || !_.addImgName.trim()) {
        _.$message.error('请先填写图片名称！');
        return;
      }
      if (!_.uploadLibFile) {
        _.$message.error('请先选择图片文件！');
        return;
      }
      _.uploadLibSubmitting = true;
      let fd = new FormData();
      fd.append('file', _.uploadLibFile.file);
      // http封装在业务失败(status!=200)或网络异常时promise不会结束、只弹全局错误提示，定时兜底恢复按钮
      setTimeout(() => { _.uploadLibSubmitting = false; }, 5000);
      _.$H.postFormData(_, _.$A.digitization.pileFunctionImgUpload, fd).then(res => {
        _.uploadLibSubmitting = false;
        const viewPath = (res.data.data || {}).viewPath || '';
        if (!viewPath) {
          _.$U.error('图片上传失败，请重试！');
          return;
        }
        _.$H.post(_, _.$A.config.add, {
          configType: '400',
          configTypeName: '桩图片库',
          configVal: viewPath,
          configName: _.addImgName.trim(),
          configDisp: _.imgLibList.length + 1
        }).then(r => {
          _.$U.success('图片已加入图库！');
          _.selectedLibImg = viewPath;
          _.closeUploadLibDialog();
          _.loadImgLib();
        });
      }).catch(() => { _.uploadLibSubmitting = false; });
    },
    //删除上传图片
    handleRemove(file, fileList) {
      this.contractFile = null;
    },
    handlePreview(file) {
      console.log(file);
    },
    handleExceed(files, fileList) {
      // this.$message.warning(`当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
    },
    //删除附件前提示
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },
    // 取消
    resetForm() {
      this.$router.push({
        name: pageConfig.listRouter
      })
    }
  },
  mounted() {
    this.init();
  },
}
</script>